module.exports = __webpack_public_path__ + "img/cli_09.4cedfa81.png";